<script>
	import { getContext } from "svelte";
	import ViewMarkdown from "../modals/ViewMarkdown.svelte";

	export let conditions;
	let msgTypes = [
		{ value: "", label: "None" },
		{ value: "onpage", label: "Display on page" },
		{ value: "modal", label: "Display in modal/popup" },
	];
	let customEndMsgParams;
	let defaultText = "";
	let textareaDisabled = [];
	let showTextarea = 0;

	const getStorage = (conditions) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		if (params) {
			if (params.customEndMsgParams) {
				customEndMsgParams = params["customEndMsgParams"];
			}
		} else {
			params = {};
		}
		// if no parameters in localStorage yet, create and populate it with default value
		if (!customEndMsgParams) {
			customEndMsgParams = [];
			for (let i = 0; i < conditions; i++) {
				customEndMsgParams.push({
					"custom-msg-type": "",
					"custom-msg": defaultText,
				});
			}
		} else {
			// if parameters in localStorage, check if it has the right number of conditions
			if (customEndMsgParams.length < conditions) {
				// if not, add the missing conditions
				for (let i = customEndMsgParams.length; i < conditions; i++) {
					customEndMsgParams.push({
						"custom-msg-type": "",
						"custom-msg": defaultText,
					});
				}
			}
		}
		params["customEndMsgParams"] = customEndMsgParams;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	getStorage();
	$: getStorage(conditions);

	const updateStorage = (parameters) => {
		let params = JSON.parse(localStorage.getItem("createStudyParams"));
		params["customEndMsgParams"] = parameters;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};
	$: updateStorage(customEndMsgParams);

	$: if (customEndMsgParams.length > 0) {
		for (let i = 0; i < customEndMsgParams.length; i++) {
			if (customEndMsgParams[i]["custom-msg-type"] === "") {
				textareaDisabled[i] = true;
				customEndMsgParams[i]["custom-msg"] = defaultText;
			} else {
				textareaDisabled[i] = false;
			}
		}
	}
	// determine whether to show the intervention percentage slider
	$: {
		showTextarea = 0;
		if (customEndMsgParams.length > 0) {
			textareaDisabled.slice(0, conditions).forEach((disabled) => {
				if (!disabled) {
					showTextarea++;
				}
			});
		}
	}

	// modal to render markdown
	const { open, close } = getContext("simple-modal");
	const viewMarkdown = (text) =>
		open(ViewMarkdown, { text: text, onClose: close });

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			let msgType = parameters[i][parameterName];
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: msgType,
			});
			let msg = parameters[i]["custom-msg"];
			if (msgType === "") {
				msg = "";
			}
			formatted.push({
				condition: i + 1,
				param: "custom-msg",
				value: msg,
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, customEndMsgParams, "custom-msg-type");
</script>

<hr />
<h3>Custom end message</h3>
<p>
	To enable this feature, make sure to select <strong
		>custom end message</strong
	> in the section below.
</p>

{#each { length: conditions } as _, ii}
	<p><strong>Condition {ii + 1}</strong></p>
	<div>
		<label for={"condition-" + (ii + 1) + ";custom-msg-type"} />
		<select
			name={"condition-" + (ii + 1) + ";custom-msg-type"}
			bind:value={customEndMsgParams[ii]["custom-msg-type"]}
		>
			{#each msgTypes as msgType}
				<option value={msgType.value}>{msgType.label}</option>
			{/each}
		</select>
	</div>
{/each}

{#if showTextarea}
	<h4>Enter message to display at the end</h4>
	{#each { length: conditions } as _, ii}
		<p>Condition {ii + 1}</p>
		<div>
			<label for="consent" />
			<textarea
				name={"consent"}
				disabled={textareaDisabled[ii]}
				rows="4"
				cols="50"
				bind:value={customEndMsgParams[ii]["custom-msg"]}
			/>
		</div>
		<button
			on:click|preventDefault={() => {
				viewMarkdown(customEndMsgParams[ii]["custom-msg"]);
			}}>View formatted consent</button
		>
	{/each}
{/if}

<style>
	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}
	textarea {
		width: 89%;
		height: 89px;
	}
</style>
